import { render, staticRenderFns } from "./AiInsightsEditor.vue?vue&type=template&id=52cab8de&scoped=true&"
import script from "./AiInsightsEditor.vue?vue&type=script&lang=ts&"
export * from "./AiInsightsEditor.vue?vue&type=script&lang=ts&"
import style0 from "./AiInsightsEditor.vue?vue&type=style&index=0&id=52cab8de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52cab8de",
  null
  
)

export default component.exports